// to match backend
export const KNOWN_IMAGE_FILE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".bmp",
  ".webp",
  ".avif",
  ".svg", // Vector images can render in modern browsers
];

export function hasImageExtension(path) {
  if (typeof path !== "string") return false;

  // Remove query params + hash
  const cleanPath = path.split("?")[0].split("#")[0].toLowerCase();

  return KNOWN_IMAGE_FILE_EXTENSIONS.some(ext => cleanPath.endsWith(ext));
}
